/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  var MARQUEE = '[data-replo-marquee-root]';
  var CAROUSEL = '#replo-section-1a3fa893-554e-47c0-ab23-64e96511d83e';
  var CTA = 'a.text.alchemy-rte, button.text.alchemy-rte';

  /*
   * Replo marquees ship with only 2 copies of the content. The keyframe shifts
   * the track by (track width / --replo-marquee-repetitions), i.e. one copy, so
   * whenever a single copy is narrower than the viewport the track runs out and
   * leaves a gap before the loop restarts. Clone copies until the track still
   * covers the viewport at the end of a cycle, and keep the repetitions var in
   * sync so the shift stays exactly one copy wide (= seamless).
   */
  function fixMarquee(root) {
    var track = root.querySelector('[data-replo-marquee-track]');
    if (!track || !track.firstElementChild) return;

    var copy = track.firstElementChild;
    var copyWidth = copy.getBoundingClientRect().width;
    if (!copyWidth) return; // not laid out yet, the observers will call again

    var needed = Math.ceil(root.clientWidth / copyWidth) + 1;
    while (track.children.length < needed) {
      track.appendChild(copy.cloneNode(true));
    }

    root.style.setProperty('--replo-marquee-repetitions', track.children.length);
  }

  /*
   * The testimonials carousel renders a fixed number of trailing slide clones,
   * enough for the 1400px cap Replo lays it out with. Now that the track runs
   * the full width of the screen (see theme.css) those clones run out: autoplay
   * stops at the last real slide and anything past the end of the track is
   * blank. Top the track up so it still reaches the right edge at that offset.
   */
  function fillCarousel(section) {
    var track = section.querySelector('[data-replo-part="slide-track"]');
    if (!track) return;

    var slides = track.querySelectorAll('[data-replo-part="slide"]');
    if (slides.length < 2) return;

    var pitch = slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
    if (pitch <= 0) return; // not laid out yet, the observers will call again

    // Every slide, clone or not, points back at the slide it was rendered from,
    // so the distinct sources are the real slides. To loop, autoplay animates
    // one slide past the last real one before snapping back, which puts the
    // furthest offset at (real + 1) * pitch.
    var sources = {};
    Array.prototype.forEach.call(slides, function(slide) {
      sources[slide.getAttribute('data-slide-source-index')] = true;
    });
    var real = Object.keys(sources).length || slides.length;

    var needed = real + 1 + Math.ceil(section.clientWidth / pitch);
    for (var i = track.children.length; i < needed; i++) {
      var clone = slides[i % slides.length].cloneNode(true);
      // Keep Replo's own bookkeeping pointing at the slides it rendered.
      clone.removeAttribute('id');
      clone.removeAttribute('data-replo-part');
      clone.removeAttribute('data-slide-index');
      clone.removeAttribute('data-slide-id');
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }
  }

  /*
   * Replo renders its CTAs with either no arrow at all or a 20x20 Feather icon,
   * so the app's buttons don't match the theme's .btn (12x12, stroke 2.5). Give
   * every Replo CTA the theme arrow instead; theme.css sizes [data-replo-arrow].
   *
   * Replo's own class names are per-element hashes that change every time a
   * section is republished, so nothing here (or in theme.css) may depend on
   * them: a CTA is identified by how it paints — a button-ish element with a
   * real background or border — and tagged with the attributes theme.css
   * styles. That also skips the tab links, which are .text.alchemy-rte too but
   * transparent on both.
   */
  function isCta(el) {
    var cs = getComputedStyle(el);
    return opaque(cs.backgroundColor) || (parseFloat(cs.borderTopWidth) > 0 && opaque(cs.borderTopColor));
  }

  // Only an alpha of 0 counts as unpainted. Testing the string for a trailing
  // ", 0)" also matches rgb(0, 0, 0), i.e. the black CTA.
  function opaque(color) {
    if (!color || color === 'transparent') return false;
    var parts = color.match(/rgba?\(([^)]+)\)/);
    if (!parts) return true;
    var channels = parts[1].split(',');
    return channels.length < 4 || parseFloat(channels[3]) > 0;
  }

  /*
   * Which of the three button styles this CTA is, read off the fill Replo gave
   * it: dark = the black CTA, green-dominant = the green one, anything lighter
   * (white, or transparent with a border) = the outline one. theme.css styles
   * [data-replo-variant] from there. Read before the theme's own colours land,
   * and stable if it runs again: our own fills classify the same way.
   */
  function variantOf(el) {
    var color = getComputedStyle(el).backgroundColor;
    var bg = color.match(/[\d.]+/g);
    if (!bg || !opaque(color)) return 'outline';
    var r = +bg[0], g = +bg[1], b = +bg[2];
    if (0.2126 * r + 0.7152 * g + 0.0722 * b < 90) return 'black';
    return (g > r && g > b) ? 'green' : 'outline';
  }

  function fixArrow(cta) {
    if (!isCta(cta)) return;

    // Replo re-renders these buttons from React, which rewrites className, so
    // the CSS hook is an attribute (those survive) and is re-asserted on every
    // pass rather than set once.
    if (!cta.hasAttribute('data-replo-variant')) {
      cta.setAttribute('data-replo-variant', variantOf(cta));
    }
    cta.setAttribute('data-replo-cta', '');
    if (cta.querySelector('[data-replo-arrow]')) return; // arrow already swapped

    // Drop whatever arrow Replo shipped: a bitmap <picture> or a Feather svg,
    // and any wrapper it leaves behind — an empty one still eats a flex gap.
    var old = cta.querySelector('picture, svg[class*="arrow"]');
    while (old && old !== cta) {
      var parent = old.parentNode;
      old.remove();
      if (parent === cta || parent.children.length || parent.textContent.trim()) break;
      old = parent;
    }

    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('role', 'presentation');
    svg.setAttribute('class', 'icon icon-arrow-right');
    svg.setAttribute('data-replo-arrow', '');
    svg.setAttribute('viewBox', '0 0 24 24');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M6 12h12.5m0 0-6-6m6 6-6 6');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(path);

    cta.appendChild(svg);
  }

  // All three fits only ever add or replace what is missing, so they are safe
  // to re-run: after Replo hydrates, on resize, or on a re-render.
  var watched = [];
  var queued = false;

  function refit() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function() {
      queued = false;
      watched.forEach(function(entry) { entry.fit(entry.el); });
    });
  }

  var resizeObserver = window.ResizeObserver ? new ResizeObserver(refit) : null;

  function watch(el, fit) {
    if (el.dataset.reploFitted) return;
    el.dataset.reploFitted = '1';
    watched.push({ el: el, fit: fit });
    fit(el);
    if (resizeObserver) resizeObserver.observe(el);
  }

  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches(MARQUEE)) watch(node, fixMarquee);
    node.querySelectorAll(MARQUEE).forEach(function(el) { watch(el, fixMarquee); });
    if (node.matches(CAROUSEL)) watch(node, fillCarousel);
    node.querySelectorAll(CAROUSEL).forEach(function(el) { watch(el, fillCarousel); });
    if (node.matches(CTA)) watch(node, fixArrow);
    node.querySelectorAll(CTA).forEach(function(el) { watch(el, fixArrow); });
  }

  scan(document.body);

  // Replo mounts and hydrates its sections after the theme's own markup is in
  // place, which both adds the sections and rebuilds what is inside them.
  new MutationObserver(function(records) {
    records.forEach(function(record) {
      record.addedNodes.forEach(scan);
    });
    refit();
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Web fonts land after first paint and change how wide the content is.
  if (document.fonts) document.fonts.ready.then(refit);

  // A CTA is recognised from its computed background, so anything scanned before
  // the stylesheets applied reads as unpainted and is skipped. Re-run once
  // everything has loaded (and shortly after, for late Replo hydration).
  window.addEventListener('load', function() {
    refit();
    setTimeout(refit, 500);
    setTimeout(refit, 1500);
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
